// Split out of RecentCoachCommentsCard.tsx (react-refresh/only-export-components)
// — a pure formatter, not a component. Behavior unchanged.

/**
 * Lightweight relative-time formatter — "2h ago", "3d ago", etc.
 * Mirrors the formatRelative helper that lives in AthleteDashboard.tsx.
 */
export function formatRelativeTime(iso: string): string {
  const ms = Date.now() - new Date(iso).getTime();
  const secs = Math.floor(ms / 1000);
  if (secs < 60) return 'just now';
  const mins = Math.floor(secs / 60);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 7) return `${days}d ago`;
  if (days < 30) return `${Math.floor(days / 7)}w ago`;
  if (days < 365) return `${Math.floor(days / 30)}mo ago`;
  return `${Math.floor(days / 365)}y ago`;
}
